import { FEEDBACK_RECORDS_EQL_FIELD } from '@modules/common/components/EqlFieldsAutoComplete/constants';
import { EqlFieldName } from '@modules/common/constants';
import { useFetchEQLFields } from '@modules/common/hooks';
import { getEqlFieldFromFieldStringValue } from '@modules/common/utils';
import { EqlField } from 'generated/graphql';
import { useMemo } from 'react';
import { FieldNames } from 'v2/core/entities/fields';

export const useGetSelectedGroupByOption = (groupBy: string | undefined) => {
  const { fields: eqlFields, isLoading: isLoadingEQLFields } =
    useFetchEQLFields({
      shouldExcludeNonGroupByFields: true,
    });

  const selectedGroupByOption = useMemo((): EqlField | null => {
    if (!groupBy) {
      return null;
    }

    if (
      groupBy === FieldNames.FeedbackRecords ||
      groupBy === EqlFieldName.FeedbackRecords
    ) {
      return FEEDBACK_RECORDS_EQL_FIELD;
    }

    return (
      eqlFields.find(
        (eqlField) =>
          eqlField.field === getEqlFieldFromFieldStringValue(groupBy),
      ) ?? null
    );
  }, [groupBy, eqlFields]);

  return {
    isLoading: selectedGroupByOption ? false : isLoadingEQLFields,
    selectedGroupByOption,
  };
};
